import { BaseMutations } from '@/store/base-mutations';
import { DataPilot } from '@/modules/data-pilot/types';
import { ReasonsCommunicationState } from './state';

export default class ReasonsCommunicationMutations extends BaseMutations<ReasonsCommunicationState> {
  SET_EVENTS(events: DataPilot.Event[]) {
    this.state.events = events;
  }

  SET_ADDRESSES(addresses: string[]) {
    this.state.addresses = addresses;
  }

  TOGGLE_LOADING(toggle: boolean) {
    this.state.loading = toggle;
  }

  SET_CLIENT_EVENTS(client_events: DataPilot.ClientEvent[]) {
    this.state.client_events = client_events;
  }

  UPD_VIEWED_EVENT(data: { id: number, client_event_status_id: number, status_name: string }): void {
    const event = this.state.client_events
      .find((item) => item.id === data.id);

    if (!event || event.client_event_status_id === data.client_event_status_id) {
      return;
    }

    event.client_event_status_id = data.client_event_status_id;
    event.status_name = data.status_name;
  }
}
